// 数字与时间
// 共 117 个单词

export default [
  {
    id: 1,
    word: "un",
    phonetic: "[\u0153\u0303]",
    type: "",
    translation: "a. num. card. \u4e00\uff1b\u7b2c\u4e00\uff1bart. ind\u00e9f. \u4e00\u4e2a\uff0c\u4e00\u6b21",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 2,
    word: "deux",
    phonetic: "[d\u00f8]",
    type: "",
    translation: "a. num. card. inv. \u4e8c\uff0c\u4e24\uff1b\u7b2c\u4e8c\uff1bn.m. inv. \u4e8c\uff0c\u4e8c\u5b57 a. num. card. inv. \u56db\uff1b\u7b2c\u56db\uff1bn.m. inv. \u56db\uff1b[\u724c\u620f]\u56db",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 3,
    word: "quatre",
    phonetic: "[katr]",
    type: "",
    translation: "\u70b9 a. num. card. inv. \u4e94\uff1b\u7b2c\u4e94\uff1bn.m. inv. \u4e94\u5b57\uff1b\uff08\u6251\u514b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 4,
    word: "cinq",
    phonetic: "[s\u025b\u0303k]",
    type: "",
    translation: "\u4e2d\u7684\uff095 adj.num.card.\uff0c adj.inv. \u516d\uff1b\uff08\u4e00\u4e2a\u6708\u4efd\u7684\uff096\u65e5\uff1b6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 5,
    word: "six",
    phonetic: "[sis]",
    type: "",
    translation: "\u70b9\u949f\uff1b\uff08\u623f\u5c4b\u6216\u623f\u95f4\u7684\uff096\u53f7\uff1b\uff08\u7eb8\u724c\u7b49\u7684\uff09\u516d\u70b9\uff1b\u4e00\u79cd \u53e4\u94dc\u5e01 a. num. card. inv. \u4e03\uff1b\u7b2c\u4e03\uff1bn.m. inv. \u4e03\uff1b\uff08\u7eb8\u724c\u7b49",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 6,
    word: "sept",
    phonetic: "[s\u03b5t]",
    type: "",
    translation: "\u7684\uff09\u4e03\u70b9",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 7,
    word: "huit",
    phonetic: "[\u0265it]",
    type: "",
    translation: "\u865a\u97f3H adj.num.card.\uff0c adj.inv. \u516b\uff1b\u7b2c\u516b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 8,
    word: "neuf",
    phonetic: "[n\u0153f]",
    type: "",
    translation: "a. \u65b0\u7684 / n.m. \u4e5d\uff1b\u65b0\u4e1c\u897f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 9,
    word: "dix",
    phonetic: "[dis]",
    type: "",
    translation: "a. num. card. inv. \u5341\uff1b\u7b2c\u5341 adj.num.card.\uff0c adj.inv. \uff08\u7b2c\uff09\u5341\u4e00 \uff1b\u7b2c\u5341\u4e00\u53f7\u623f\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 10,
    word: "onze",
    phonetic: "[\u0254\u0303z]",
    type: "",
    translation: "\u6216\u684c\u5b50\uff1b\uff08\u4e00\u4e2a\u6708\u4efd\u7684\uff09\u5341\u4e00\u65e5\uff1b\uff0811\u4eba\u7ec4\u6210\u7684\uff09\u8db3\u7403 \u961f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 11,
    word: "douze",
    phonetic: "[duz]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u5341\u4e8c\uff1b\u7b2c\u5341\u4e8c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 12,
    word: "treize",
    phonetic: "[tr\u03b5z]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u5341\u4e09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 13,
    word: "quatorze",
    phonetic: "[kat\u0254rz]",
    type: "",
    translation: "a. num. card. inv. \u5341\u56db\uff1b\u7b2c\u5341\u56db\uff1bn.m. inv. \u5341\u56db a. num. card. inv. \u5341\u4e94\uff1b\u7b2c\u5341\u4e94\uff1bn.m. inv. \u5341\u4e94\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 14,
    word: "quinze",
    phonetic: "[k\u025b\u0303z]",
    type: "",
    translation: "[\u4f53]\u6a44\u6984\u7403\u961f adj.num.card.\uff0c adj.inv. \u5341\u516d\uff1b\u7b2c\u5341\u516d\uff1b\uff08\u4e00\u4e2a\u6708\u4efd",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 15,
    word: "seize",
    phonetic: "[s\u03b5z]",
    type: "",
    translation: "\u7684\uff09\u5341\u516d\u65e5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 16,
    word: "dix-sept",
    phonetic: "[dis\u03b5t]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u5341\u4e03\uff1b\u7b2c\u5341\u4e03",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 17,
    word: "dix-huit",
    phonetic: "[diz\u0265it]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u5341\u516b\uff1b\u7b2c\u5341\u516b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 18,
    word: "dix-neuf",
    phonetic: "[dizn\u0153f]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u5341\u4e5d\uff1b\u7b2c\u5341\u4e5d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 19,
    word: "vingt",
    phonetic: "[v\u025b\u0303]",
    type: "",
    translation: "adj.num.card. \u4e8c\u5341 \u611f\u53f9\u8bcd interj. \u5f53\u5fc3\uff01\u7559\u795e\uff01 Vingt-deux, voil\u00e0 les",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 20,
    word: "vingt-deux",
    phonetic: "[v\u025b\u0303td\u00f8]",
    type: "",
    translation: "flics...",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 21,
    word: "trente",
    phonetic: "[tr\u0251\u0303t]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u4e09\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 22,
    word: "trente-trois",
    phonetic: "[tr\u0251\u0303ttrwa]",
    type: "",
    translation: "\u6570\u5b57 33",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 23,
    word: "quarante",
    phonetic: "[kar\u0251\u0303t]",
    type: "",
    translation: "a. num. card. inv. \u56db\u5341\uff1b\u7b2c\u56db\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 24,
    word: "cinquante",
    phonetic: "[s\u025b\u0303k\u0251\u0303t]",
    type: "",
    translation: "a. num. card. inv. \u4e94\u5341\uff1b\u7b2c\u4e94\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 25,
    word: "soixante",
    phonetic: "[swas\u0251\u0303t]",
    type: "",
    translation: "adj.num.card.\uff0c adj.inv. \u516d\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 26,
    word: "soixante-dix",
    phonetic: "[swas\u0251\u0303tdis]",
    type: "",
    translation: "n.m.\uff0c adj. \u4e03\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 27,
    word: "quatre-vingts",
    phonetic: "[katr\u0259v\u025b\u0303]",
    type: "",
    translation: "a. num. card. \u516b\u5341\uff1b\u7b2c\u516b\u5341 28 quatre-vingt-un \u516b\u5341\u4e00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 28,
    word: "quatre-vingt-dix",
    phonetic: "[katr\u0259v\u025b\u0303dis]",
    type: "",
    translation: "adj.num.card. \u4e5d\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 29,
    word: "cent",
    phonetic: "[s\u0251\u0303]",
    type: "",
    translation: "a. num. card. \u767e\uff1b\u7b2c\u4e00\u767e\uff1b\u5f88\u591a\uff0c\u8bb8\u591a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 30,
    word: "mille",
    phonetic: "[mil]",
    type: "",
    translation: "a. num. card. inv. \u4e00\u5343\uff1b\u7b2c\u4e00\u5343\uff1b\u8bb8\u591a\u7684 n.m. \u767e\u4e07\uff1b\u767e\u4e07\u6cd5\u90ce\u3001\u767e\u4e07\u5143\u6216\u767e\u4e07\u9551\u7b49\uff1b\u5de8\u5927\u6570\u76ee\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 31,
    word: "million",
    phonetic: "[milj\u0254\u0303]",
    type: "",
    translation: "\u8bb8\u8bb8\u591a\u591a\uff0c \u65e0\u6570\uff1b\u4e00\u4e07\u6cd5\u90ce[\u6309\u65e7\u6cd5\u90ce\u4e00\u767e\u4e07\u6cd5\u90ce\u6298\u5408\u65b0 \u6cd5\u90ce\u4e00\u767e\u4e07\u751f\u4e01\u8ba1\u7b97]",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 32,
    word: "milliard",
    phonetic: "[miljar]",
    type: "",
    translation: "n.m. \u5341\u4ebf\uff1b\u5de8\u5927\u6570\u76ee a. \u7b2c\u4e00\u7684\uff1b\u539f\u59cb\u7684\uff1b\u7b2c\u4e00\u4f4d\u7684\uff0c\u9996\u8981\u7684\uff1b\u521d\u6b65\u7684\uff0c\u57fa\u672c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 33,
    word: "premier",
    phonetic: "[pr\u0259mje, -\u03b5r]",
    type: "",
    translation: "\u7684 1 of 4 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 34,
    word: "deuxi\u00e8me",
    phonetic: "[d\u00f8zj\u03b5m]",
    type: "",
    translation: "a. num. ord. \u7b2c\u4e8c\uff1bn. \u7b2c\u4e8c\u4e2a\uff0c\u7b2c\u4e8c\u540d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 35,
    word: "second",
    phonetic: "[s(\u0259)g\u0254\u0303, -d]",
    type: "",
    translation: "a. \u7b2c\u4e8c\uff1b\u53e6\u5916\u4e00\u4e2a\uff1b\u6b21\u8981\u7684\uff0c\u4e8c\u7b49\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 36,
    word: "troisi\u00e8me",
    phonetic: "[trwazj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u4e09\u4e2a\uff1b\u7b2c\u4e09\uff1b\u4e09\u5206\u4e4b\u4e00\u7684 a. num. ord. \u7b2c\u56db\uff1bn. \u7b2c\u56db\u540d\uff1bn.f. \u56db\u5e74\u7ea7[\u521d\u4e2d\u4e09\u5e74",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 37,
    word: "quatri\u00e8me",
    phonetic: "[katrij\u03b5m]",
    type: "",
    translation: "\u7ea7]\uff1b[\u6c7d]\u7b2c\u56db\u6863\u901f\u5ea6 a. num. ord. \u7b2c\u4e94\uff08\u70b9\uff09\uff1bn. \u7b2c\u4e94\u540d\uff1ba.\uff0c n.m. \u4e94\u5206",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 38,
    word: "cinqui\u00e8me",
    phonetic: "[s\u025b\u0303kj\u03b5m]",
    type: "",
    translation: "\u4e4b\u4e00\uff08\u7684\uff09\uff1bn.f.\uff08\u6cd5\u56fd\u7684\uff09\u4e94\u5e74\u7ea7\uff1b\uff08\u8f66\u8f86\u7684\uff09\u7b2c\u4e94\u6321",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 39,
    word: "sixi\u00e8me",
    phonetic: "[sizj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u516d\u5206\u4e4b\u4e00\uff1b\u7b2c\u516d\u4e2a\uff1b\u7b2c\u516d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 40,
    word: "septi\u00e8me",
    phonetic: "[s\u03b5tj\u03b5m]",
    type: "",
    translation: "a. num. ord. \u7b2c\u4e03\uff1bn. \u7b2c\u4e03\u4e2a\uff0c\u7b2c\u4e03\u540d\uff1bn.f. \u4e03\u5e74\u7ea7 adj.num.ord. \u7b2c\u516b\uff1b\u7b2c\u516b\u4e2a\uff0c\u7b2c\u516b\u540d\uff1b\u516b\u5206\u4e4b\u4e00\u7684\uff1b\u516b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 41,
    word: "huiti\u00e8me",
    phonetic: "['\u0265itj\u03b5m]",
    type: "",
    translation: "\u865a\u97f3H \u5206\u4e4b\u4e00 \uff1b\u516b\u5e74\u7ea7",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 42,
    word: "neuvi\u00e8me",
    phonetic: "[n\u0153vj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u4e5d\uff08\u4e2a\uff09 \uff1b\u4e5d\u5206\u4e4b\u4e00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 43,
    word: "dixi\u00e8me",
    phonetic: "[dizj\u03b5m]",
    type: "",
    translation: "a.\uff0c n.m. \u5341\u5206\u4e4b\u4e00\uff08\u7684\uff09 adj.num.ord. \u7b2c\u5341\u4e00\uff08\u4e2a\uff09\uff1b\u5341\u4e00\u5206\u4e4b\u4e00\uff1b[\u4e50]\u5341\u4e00\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 44,
    word: "onzi\u00e8me",
    phonetic: "[\u0254\u0303zj\u03b5m]",
    type: "",
    translation: "\uff08\u97f3\u7a0b\uff09 adj.num.ord. \u5341\u4e8c\u5206\u4e4b\u4e00\uff1b\u7b2c\u5341\u4e8c\u4e2a\uff1b\u5341\u4e8c\u5206\u4e4b\u4e00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 45,
    word: "douzi\u00e8me",
    phonetic: "[duzj\u03b5m]",
    type: "",
    translation: "\uff08\u7684\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 46,
    word: "treizi\u00e8me",
    phonetic: "[tr\u03b5zj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u5341\u4e09\u5206\u4e4b\u4e00\uff1b\u7b2c\u5341\u4e09\u4e2a\uff1b\u7b2c\u5341\u4e09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 47,
    word: "quatorzi\u00e8me",
    phonetic: "[kat\u0254rzj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u5341\u56db\uff08\u4e2a\uff09\uff1b\u5341\u56db\u5206\u4e4b\u4e00\uff08\u7684\uff09 adj.num.ord. \u7b2c\u5341\u4e94\uff1b \u7b2c\u5341\u4e94\u4e2a\uff0c \u7b2c\u5341\u4e94\u540d\uff1b\u5341\u4e94\u5206",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 48,
    word: "quinzi\u00e8me",
    phonetic: "[k\u025b\u0303zj\u03b5m]",
    type: "",
    translation: "\u4e4b\u4e00\uff08\u7684\uff09 adj.num.ord. \u7b2c\u5341\u516d\uff08\u4e2a\uff09\uff0c\u7b2c\u5341\u516d\u540d\uff1b\u5341\u516d\u4e16\u7eaa\uff1b",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 49,
    word: "seizi\u00e8me",
    phonetic: "[s\u03b5zj\u03b5m]",
    type: "",
    translation: "\uff08\u5df4\u9ece\uff09\u7b2c\u5341\u516d\u533a\uff1b\u7b2c\u5341\u516d\u5929\uff1b\u5341\u516d\u5206\u4e4b\u4e00\uff1b[\u4e50]\u5341\u516d\u5ea6 \uff08\u97f3\u7a0b\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 50,
    word: "dix-huiti\u00e8me",
    phonetic: "[diz\u0265itj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u5341\u516b\uff1b\u5341\u516b\u5206\u4e4b\u4e00\uff08\u7684\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 51,
    word: "dix-neuvi\u00e8me",
    phonetic: "[dizn\u0153vj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u5341\u4e5d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 52,
    word: "vingti\u00e8me",
    phonetic: "[v\u025b\u0303tj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u4e8c\u5341\u5206\u4e4b\u4e00\uff1b\u7b2c\u4e8c\u5341\u4e2a\uff1b\u7b2c\u4e8c\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 53,
    word: "trenti\u00e8me",
    phonetic: "[tr\u0251\u0303tj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u4e09\u5341\u5206\u4e4b\u4e00\uff1b\u7b2c\u4e09\u5341\u4e2a\uff1b\u7b2c\u4e09\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 54,
    word: "quaranti\u00e8me",
    phonetic: "[kar\u0251\u0303tj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u56db\u5341\uff08\u4e2a\uff09\uff1b\u56db\u5341\u5206\u4e4b\u4e00\uff08\u7684\uff09 adj.num.ord. \u4e94\u5341\u5206\u4e4b\u4e00\uff1b\u7b2c\u4e94\u5341\u4e2a\uff1b\u7b2c\u4e94\u5341\uff1b\u4e94\u5341\u5206",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 55,
    word: "cinquanti\u00e8me",
    phonetic: "[s\u025b\u0303k\u0251\u0303tj\u03b5m]",
    type: "",
    translation: "\u4e4b\u4e00\u7684",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 56,
    word: "soixanti\u00e8me",
    phonetic: "[swas\u0251\u0303tj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u516d\u5341\u5206\u4e4b\u4e00\uff1b\u7b2c\u516d\u5341\u4e2a\uff1b\u7b2c\u516d\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 57,
    word: "soixante-dixi\u00e8me",
    phonetic: "[swas\u0251\u0303tdizj\u03b5m]",
    type: "",
    translation: "n.m.\uff0c adj. \u4e03\u5341\u5206\u4e4b\u4e00\uff1b\u7b2c\u4e03\u5341\u4e2a\uff1b\u7b2c\u4e03\u5341",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 58,
    word: "quatre-vingti\u00e8me",
    phonetic: "[katr\u0259v\u025b\u0303tj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u516b\u5341\uff08\u4e2a\uff09\uff1a \u516b\u5341\u5206\u4e4b\u4e00\uff08\u7684\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 59,
    word: "quatre-vingt-dixi\u00e8me",
    phonetic: "[katr\u0259v\u025b\u0303dizj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u4e5d\u5341\uff08\u4e2a\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 60,
    word: "centi\u00e8me",
    phonetic: "[s\u0251\u0303tj\u03b5m]",
    type: "",
    translation: "a. num. ord. \u7b2c\u4e00\u767e\uff1ba.\uff0c n.m. \u767e\u5206\u4e4b\u4e00 adj.num.ord. \u7b2c\u4e00\u5343\uff08\u4e2a\uff09\uff1b\u5343\u5206\u4e4b\u4e00\uff08\u7684\uff09\uff1b[\u6570\uff0c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 61,
    word: "milli\u00e8me",
    phonetic: "[milj\u03b5m]",
    type: "",
    translation: "\u519b]\u89d2\u5bc6\u5ea6\uff0c \u5bc6\u4f4d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 62,
    word: "millioni\u00e8me",
    phonetic: "[milj\u0254nj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u4e00\u767e\u4e07\uff08\u4e2a\uff09 \uff1b\u767e\u4e07\u5206\u4e4b\u4e00\uff08\u7684\uff09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 63,
    word: "milliardi\u00e8me",
    phonetic: "[miljardj\u03b5m]",
    type: "",
    translation: "adj.num.ord. \u7b2c\u5341\u4ebf\uff1b\u5341\u4ebf\u5206\u4e4b\u4e00\u7684\uff1b\u5341\u4ebf\u5206\u4e4b\u4e00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 64,
    word: "heure",
    phonetic: "[\u0153r]",
    type: "",
    translation: "n.f. \u5c0f\u65f6\uff1b\u65f6\u95f4\uff1b\u70b9\u949f\uff1b\u949f\u70b9\uff1b\u65f6\u523b\uff0c\u65f6\u671f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 65,
    word: "temps",
    phonetic: "[t\u0251\u0303]",
    type: "",
    translation: "n.m. \u65f6\u95f4\uff1b\u9636\u6bb5\uff1b\u65f6\u4ee3\uff0c\u65f6\u671f\uff1b\u65f6\u5019\uff1b[\u8bed]\u65f6\u6001\uff1b\u5929\u6c14",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 66,
    word: "date",
    phonetic: "[dat]",
    type: "",
    translation: "n.f. \u65e5\u671f\uff0c\u5e74\u6708\u65e5\uff1b\u65f6\u671f\uff0c\u65f6\u4ee3",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 67,
    word: "demi",
    phonetic: "[d(\u0259)mi]",
    type: "",
    translation: "a. \u4e00\u534a\u7684\uff0c\u534a\u4e2a\u7684\uff1b\u4e0d\u5b8c\u5168\u7684\uff1bn.m. \u4e00\u534a\uff0c\u534a\u4e2a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 68,
    word: "tiers",
    phonetic: "[tj\u03b5r, -s]",
    type: "",
    translation: "n.m. \u4e09\u5206\u4e4b\u4e00\uff1b\u7b2c\u4e09\u8005\uff1b\u5916\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 69,
    word: "quart",
    phonetic: "[kar]",
    type: "",
    translation: "n.m. \u56db\u5206\u4e4b\u4e00\uff1b\u56db\u5206\u4e4b\u4e00\u5347\u7684\u5c0f\u74f6\uff1b\u56db\u5206\u4e4b\u4e00\u5347\u7684\u91cf",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 70,
    word: "virgule",
    phonetic: "[virgyl]",
    type: "",
    translation: "n.f. \u9017\u53f7\uff1b[\u6570]\u5c0f\u6570\u70b9 2 of 4 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No. n.m. \u5c0f\u5706\u70b9\uff1b\u6807\u70b9\uff1b\u53e5\u53f7\uff1b\u5206\u6570\uff1b\u767e\u5206\u70b9\uff1b\u5730\u65b9\uff1b\u8981",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 71,
    word: "point",
    phonetic: "[pw\u025b\u0303]",
    type: "",
    translation: "\u70b9\uff1b\u7a0b\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 72,
    word: "jour",
    phonetic: "[\u0292ur]",
    type: "",
    translation: "n.m. \u5929\uff0c\u65e5\u5b50\uff1b\u592a\u9633\u5149\uff1b\u767d\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 73,
    word: "journ\u00e9e",
    phonetic: "[\u0292urne]",
    type: "",
    translation: "n.f. \u767d\u5929\uff1b\u4e00\u5929\uff0c\u4e00\u663c\u591c\uff1b\u5de5\u4f5c\u65e5\uff1b\u65e5\u85aa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 74,
    word: "matin",
    phonetic: "[mat\u025b\u0303]",
    type: "",
    translation: "n.m. \u65e9\u6668\uff1b\u4e0a\u5348\uff0c\u4e0a\u534a\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 75,
    word: "midi",
    phonetic: "[midi]",
    type: "",
    translation: "n.m. \u4e2d\u5348\uff0c\u6b63\u5348",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 76,
    word: "apr\u00e8s-midi",
    phonetic: "[apr\u03b5midi]",
    type: "",
    translation: "n.m. \u4e0b\u5348",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 77,
    word: "soir",
    phonetic: "[swar]",
    type: "",
    translation: "n.m. \u508d\u665a\uff0c\u9ec4\u660f\uff1b\u665a\u95f4\uff0c\u665a\u4e0a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 78,
    word: "soir\u00e9e",
    phonetic: "[sware]",
    type: "",
    translation: "n.f. \u665a\u95f4\uff0c\u665a\u4e0a\uff1b\u665a\u4f1a",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 79,
    word: "demain",
    phonetic: "[d(\u0259)m\u025b\u0303]",
    type: "",
    translation: "adv. \u660e\u5929\uff0c\u660e\u65e5\uff1b\u5c06\u6765\uff0c\u672a\u6765",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 80,
    word: "hier",
    phonetic: "[j\u03b5r]",
    type: "",
    translation: "adv. \u6628\u5929\uff0c\u6628\u65e5\uff1b\u8fd1\u6765\uff0c\u6700\u8fd1\uff0c\u8fc7\u53bb",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 81,
    word: "veille",
    phonetic: "[v\u03b5j]",
    type: "",
    translation: "n.f. \u71ac\u591c\uff1b\u591c\u95f4\u503c\u73ed\uff0c\u591c\u95f4\u8b66\u6212\uff1b\u524d\u4e00\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 82,
    word: "apr\u00e8s-demain",
    phonetic: "[apr\u03b5dm\u025b\u0303]",
    type: "",
    translation: "adv. \u540e\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 83,
    word: "nuit",
    phonetic: "[n\u0265i]",
    type: "",
    translation: "n.f. \u591c\uff0c\u591c\u665a\uff0c\u591c\u95f4\uff1b\u6f06\u9ed1\uff0c\u9ed1\u6697",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 84,
    word: "minuit",
    phonetic: "[min\u0265i]",
    type: "",
    translation: "n.m. \u534a\u591c\uff0c\u5348\u591c\uff1b\u5b50\u591c12\u65f6\uff0c\u96f6\u65f6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 85,
    word: "moiti\u00e9",
    phonetic: "[mwatje]",
    type: "",
    translation: "n.f. \u4e00\u534a\uff1b\u4e00\u534a\u5de6\u53f3\uff1b\u8001\u5a46",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 86,
    word: "plupart",
    phonetic: "[plypar]",
    type: "",
    translation: "n.f. \u5927\u591a\u6570\uff0c\u5927\u90e8\u5206\uff1b\u5927\u591a\u6570\u4eba\uff0c\u5927\u90e8\u5206\u4eba",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 87,
    word: "semaine",
    phonetic: "[s(\u0259)m\u03b5n]",
    type: "",
    translation: "n.f. \u4e00\u5468\uff1b\u5de5\u4f5c\u5468\uff1b\u5468\uff0c\u661f\u671f\uff1b\u5468\u85aa",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 88,
    word: "lundi",
    phonetic: "[l\u0153\u0303di]",
    type: "",
    translation: "n.m. \u661f\u671f\u4e00",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 89,
    word: "mardi",
    phonetic: "[mardi]",
    type: "",
    translation: "n.m. \u661f\u671f\u4e8c",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 90,
    word: "mercredi",
    phonetic: "[m\u03b5rkr\u0259di]",
    type: "",
    translation: "n.m. \u661f\u671f\u4e09",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 91,
    word: "jeudi",
    phonetic: "[\u0292\u00f8di]",
    type: "",
    translation: "n.m. \u661f\u671f\u56db",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 92,
    word: "vendredi",
    phonetic: "[v\u0251\u0303dr\u0259di]",
    type: "",
    translation: "n.m. \u661f\u671f\u4e94",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 93,
    word: "samedi",
    phonetic: "[samdi]",
    type: "",
    translation: "n.m. \u661f\u671f\u516d",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 94,
    word: "dimanche",
    phonetic: "[dim\u0251\u0303\u222b]",
    type: "",
    translation: "n.m. \u661f\u671f\u65e5",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 95,
    word: "mois",
    phonetic: "[mwa]",
    type: "",
    translation: "n.m. \u6708\uff0c\u6708\u4efd\uff1b\u4e00\u4e2a\u6708\u7684\u65f6\u95f4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 96,
    word: "janvier",
    phonetic: "[\u0292\u0251\u0303vje]",
    type: "",
    translation: "n.m. \u4e00\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 97,
    word: "f\u00e9vrier",
    phonetic: "[fevrije]",
    type: "",
    translation: "n.m. \u4e8c\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 98,
    word: "mars",
    phonetic: "[mars]",
    type: "",
    translation: "n.m. \u4e09\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 99,
    word: "avril",
    phonetic: "[avril]",
    type: "",
    translation: "n.m. \u56db\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 100,
    word: "mai",
    phonetic: "[m\u03b5]",
    type: "",
    translation: "n.m. \u4e94\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 101,
    word: "juin",
    phonetic: "[\u0292\u0265\u025b\u0303]",
    type: "",
    translation: "n.m. \u516d\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 102,
    word: "juillet",
    phonetic: "[\u0292\u0265ij\u03b5]",
    type: "",
    translation: "n.m. \u4e03\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 103,
    word: "ao\u00fbt",
    phonetic: "[u(t)]",
    type: "",
    translation: "n.m. \u516b\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 104,
    word: "septembre",
    phonetic: "[s\u03b5pt\u0251\u0303br]",
    type: "",
    translation: "n.m. \u4e5d\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 105,
    word: "octobre",
    phonetic: "[\u0254kt\u0254br]",
    type: "",
    translation: "n.m. \u5341\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 106,
    word: "novembre",
    phonetic: "[n\u0254v\u0251\u0303br]",
    type: "",
    translation: "n.m. \u5341\u4e00\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 107,
    word: "d\u00e9cembre",
    phonetic: "[des\u0251\u0303br]",
    type: "",
    translation: "n.m. \u5341\u4e8c\u6708",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 108,
    word: "an",
    phonetic: "[\u0251\u0303]",
    type: "",
    translation: "n.m. \u5e74\uff1b\u5e74\u9f84",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 109,
    word: "ann\u00e9e",
    phonetic: "[ane]",
    type: "",
    translation: "n.f. \u5e74\uff0c\u5e74\u4efd\uff1b\u5e74\u5ea6",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 110,
    word: "d\u00e9cennie",
    phonetic: "[deseni]",
    type: "",
    translation: "n.f. \u5341\u5e74",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 111,
    word: "si\u00e8cle",
    phonetic: "[sj\u03b5kl]",
    type: "",
    translation: "n.m. \u767e\u5e74\uff1b\u4e16\u7eaa\uff1b\u65f6\u671f\uff1b\u65f6\u4ee3\uff1b\u957f\u65f6\u671f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 112,
    word: "saison",
    phonetic: "[s\u03b5z\u0254\u0303]",
    type: "",
    translation: "n.f. \u5b63\uff1b\u5b63\u8282\uff1b\u5f53\u4ee4\u671f",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 113,
    word: "hiver",
    phonetic: "[iv\u03b5r]",
    type: "",
    translation: "n.m. \u51ac\uff0c\u51ac\u5b63\uff0c\u51ac\u5929\uff1b\u5bd2\u51ac",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 114,
    word: "printemps",
    phonetic: "[pr\u025b\u0303t\u0251\u0303]",
    type: "",
    translation: "n.m. \u6625\u5929\uff0c\u6625\u5b63\uff1b\u9752\u6625\uff0c\u9752\u5e74\u65f6\u4ee3 3 of 4 \u5355\u8bcd \u97f3\u6807 \u89e3\u91ca No.",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 115,
    word: "\u00e9t\u00e9",
    phonetic: "[ete]",
    type: "",
    translation: "n.m. \u590f\uff0c\u590f\u5b63\uff0c\u590f\u5929",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 116,
    word: "automne",
    phonetic: "[ot\u0254n]",
    type: "",
    translation: "ou [\u0254t\u0254n] n.m. \u79cb\u5929\uff0c\u79cb\u5b63",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
  {
    id: 117,
    word: "z\u00e9ro",
    phonetic: "[zero]",
    type: "",
    translation: "n.m. \u96f6\uff1b\u65e0\uff1b\u65e0\u80fd\u7684\u4eba\uff0c\u4e00\u65e0\u53ef\u53d6\u7684\u4eba 4 of 4",
    commonMeanings: [],
    example: "",
    exampleTranslation: "",
    image: "",
    usages: [],
    derivatives: [],
    synonymsAntonyms: [],
  },
];
